import {
  LegacyModal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ButtonGroup,
  BasicButton,
  PrimaryButton,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { Form } from "formik";
import { Trans } from "react-i18next";

export function FormModal(props: {
  title: string;
  children: React.ReactNode;
  onClose?: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  continueText?: string;
  secondaryText?: string;
  variant?: "success" | "danger";
  testID?: string;
}) {
  return (
    <LegacyModal width="520px" testID={props.testID}>
      <ModalHeader
        close={props.onClose ? props.onClose : props.onCancel}
        title={props.title}
        testID={`${slugify(props.title)}-modal-header`}
      />
      <ModalContent testID={`${slugify(props.title)}-modal-content`}>
        <Form>{props.children}</Form>
      </ModalContent>
      <ModalFooter testID={`${slugify(props.title)}-modal-footer`}>
        <ButtonGroup>
          <BasicButton
            size="medium"
            onPress={props.onCancel}
            testID={`${slugify(props.title)}-cancel-button`}
          >
            {props.secondaryText ?? <Trans>Cancel</Trans>}
          </BasicButton>
          <PrimaryButton
            testID={`${slugify(props.title)}-${
              slugify(props.continueText) || slugify("continue")
            }-button`}
            size="medium"
            onPress={props.onSubmit}
            variant={props.variant ?? "danger"}
          >
            {props.continueText ?? <Trans>Continue</Trans>}
          </PrimaryButton>
        </ButtonGroup>
      </ModalFooter>
    </LegacyModal>
  );
}
